import * as Types from './types';
import { actionTypes } from './constants';

export const toggleRestart = (restart: boolean): Types.IToggleRestartAction => ({
    type: actionTypes.TOGGLE_RESTART,
    payload: restart
});

export const updateSlidesCount = (slidesCount: number): Types.ISlidesCountUpdateAction => ({
    type: actionTypes.SLIDES_COUNT_UPDATE,
    payload: slidesCount
});

export const updateCarouselConfig = (config: Types.ICarouselConfig): Types.IConfigUpdateAction => ({
    type: actionTypes.CONFIG_UPDATE,
    payload: config
});

export const updateItemWidth = (itemWidth: number, isSilent?: boolean): Types.IItemWidthUpdateAction => ({
    type: actionTypes.ITEM_WIDTH_UPDATE,
    payload: itemWidth,
    isSilent
});

export const updateContainerShift = (containerShift: number): Types.IContainerShiftUpdateAction => ({
    type: actionTypes.CONTAINER_SHIFT_UPDATE,
    payload: containerShift
});

export const updateItemShift = (itemShift: number): Types.IItemShiftUpdateAction => ({
    type: actionTypes.ITEM_SHIFT_UPDATE,
    payload: itemShift
});

export const updateNumerationData = (
    { fontSize, width }: { fontSize: number; width: number }, isSilent?: boolean
): Types.INumerationDataUpdateAction => ({
    type: actionTypes.NUMERATION_DATA_UPDATE,
    payload: { fontSize, width },
    isSilent
});

export const moveLeft = (diff: number): Types.IMoveLeftAction => ({
    type: actionTypes.MOVE_LEFT,
    payload: diff
});

export const moveRight = (diff: number): Types.IMoveRightAction => ({
    type: actionTypes.MOVE_RIGHT,
    payload: diff
});
